import { useState, type ReactNode } from 'react';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { Field } from '@/components/shared/field';
import { FormModal } from '@/components/shared/form-modal';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

/** Coleta o motivo e confirma a ação destrutiva (cancelar, registrar ausência). */
export function ReasonModal({
  open,
  onOpenChange,
  title,
  description,
  confirmTitle,
  confirmDescription,
  confirmLabel,
  trigger,
  onConfirm,
  suggestions = [],
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: string;
  description: string;
  confirmTitle: string;
  confirmDescription: string;
  confirmLabel: string;
  trigger?: ReactNode;
  onConfirm: (reason: string) => Promise<unknown>;
  suggestions?: string[];
}) {
  const [reason, setReason] = useState('');
  return (
    <FormModal
      open={open}
      onOpenChange={(v) => {
        if (!v) setReason('');
        onOpenChange(v);
      }}
      title={title}
      description={description}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Voltar
          </Button>
          <ConfirmDialog
            trigger={trigger ?? <Button variant="destructive">{confirmLabel}</Button>}
            title={confirmTitle}
            description={confirmDescription}
            confirmLabel={confirmLabel}
            onConfirm={async () => {
              await onConfirm(reason.trim());
              setReason('');
              onOpenChange(false);
            }}
          />
        </>
      }
    >
      <div className="grid gap-3">
        <Field id="reason" label="Motivo">
          <Textarea id="reason" rows={3} value={reason} maxLength={300} onChange={(e) => setReason(e.target.value)} />
        </Field>
        {suggestions.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {suggestions.map((s) => (
              <Button key={s} type="button" size="xs" variant="outline" onClick={() => setReason(s)}>
                {s}
              </Button>
            ))}
          </div>
        )}
      </div>
    </FormModal>
  );
}
